// extracted by mini-css-extract-plugin
module.exports = {"wrap":"s_wrap__2Ag53","buttonsWrap":"s_buttonsWrap__1PN8t","button":"s_button__1fYQl","icon":"s_icon__2mBw7","active":"s_active__1aMcB"};